import { render, staticRenderFns } from "./CustomerManage.vue?vue&type=template&id=d47e1a3a&scoped=true&"
import script from "./CustomerManage.js?vue&type=script&lang=js&"
export * from "./CustomerManage.js?vue&type=script&lang=js&"
import style0 from "@/assets/style/common.css?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d47e1a3a",
  null
  
)

export default component.exports